import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash.noop'

import TiledSizePickerTile from '../../containers/TiledSizePickerTile'
import mapStateToAvailabilityProps from '../../../../reducers/availability/mappers'
import { by } from '../../../../utils'

import * as Styled from './TiledSizePicker.styles'

export class TiledSizePicker extends Component {
  render() {
    const { message, type, shortValue, partNumber, combinations, selectPartNumber, sizeInfo } = this.props

    return (
      <Styled.Container>
        <Styled.HeaderContainer>
          <Styled.Header data-test='tiled-size-picker-header'>
            {type}: {shortValue}
            {message}
          </Styled.Header>
          {sizeInfo()}
        </Styled.HeaderContainer>
        <Styled.Box data-test='tiled-size-picker-box'>
          <TiledSizePickerTileList
            selectPartNumber={selectPartNumber}
            partNumber={partNumber}
            combinations={combinations}
            type={type}
          />
        </Styled.Box>
      </Styled.Container>
    )
  }
}

TiledSizePicker.propTypes = {
  type: PropTypes.string.isRequired,
  shortValue: PropTypes.string.isRequired,
  partNumber: PropTypes.string.isRequired,
  combinations: PropTypes.array.isRequired,
  selectPartNumber: PropTypes.func.isRequired,
  sizeInfo: PropTypes.func,
  message: PropTypes.node.isRequired
}

TiledSizePicker.defaultProps = {
  sizeInfo: noop
}
const TiledSizePickerTileList = props => {
  const { type, partNumber: rootPartNumber, selectPartNumber, combinations } = props
  return combinations
    .filter(combination => combination.attributes?.find(by.typeOf(type)))
    .map((combination, key) => (
      <TiledSizePickerTile key={key} {...{ type, rootPartNumber, selectPartNumber }} {...combination} />
    ))
}

export default connect(mapStateToAvailabilityProps)(TiledSizePicker)
